import { Site } from '@/models/Site';

export class Widget {
    id?: number;
    position: number;
    sites: Site[];
    libelle: string;
    dashboardId: number;
    typeWidgetId?: number;
    parametres?: any[];
    autresParametres?: any[];

    constructor(position: number, sites: Site[], libelle: string, dashboardId: number, typeWidgetId: number | undefined){
        this.position = position;
        this.sites = sites;
        this.libelle = libelle;
        this.dashboardId = dashboardId;
        this.typeWidgetId = typeWidgetId;
    }
}
